module.exports = __webpack_public_path__ + "static/media/realtimerounded-bold.6b7356ec.woff2";